import { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { NavLink } from '@spotted-zebra-uk/ui-components';
import { HelmetAndPageAnnouncer } from 'components/organisms/HelmetAndPageAnnouncer/HelmetAndPageAnnouncer';
import { QuestionnaireStageCandidateQuery } from 'generated/graphql';
import PortalFooter from '../CandidatePortal/PortalLayout/PortalFooter';
import PortalNavbar from '../CandidatePortal/PortalLayout/PortalNavbar';
import {
  getCompanyLogoUrl,
  getPortalBrandingStyle,
} from '../CandidatePortal/CandidatePortal.helpers';

type EligibilityRole = NonNullable<QuestionnaireStageCandidateQuery['myRole']>;

/** Portal layout (navbar, back link, footer) shared by the eligibility pages. */
const RoleStageEligibilityLayout: FC<{
  role: EligibilityRole;
  pageTitle: string;
  backUrl: string;
  children: ReactNode;
}> = ({ role, pageTitle, backUrl, children }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const branding = role.company.branding;

  return (
    <>
      <HelmetAndPageAnnouncer pageTitle={pageTitle} />
      <div
        className="RoleStageEligibility"
        style={getPortalBrandingStyle(branding)}
        aria-live="polite"
      >
        <PortalNavbar
          companyName={role.company.name}
          logoUrl={getCompanyLogoUrl(role.company)}
        />
        <nav className="RoleStageEligibility__Nav">
          <NavLink
            to={backUrl}
            onClick={e => {
              e.preventDefault();
              navigate(backUrl);
            }}
            aria-label={t('roles.backToStageList')}
            direction="backward"
            className="RoleStageEligibility__Nav__BackButton"
          >
            {t('roles.stageList')}
          </NavLink>
        </nav>
        {children}
        <PortalFooter
          companyName={role.company.name}
          websiteLinkUrl={branding?.websiteLinkUrl}
          careersLinkUrl={branding?.careersLinkUrl}
        />
      </div>
    </>
  );
};

export default RoleStageEligibilityLayout;
